<template>
    <div class="c-listbox"
        :data-component-name="$options.name"
    >
        <div class="c-listbox-search q-pb-md">
            <div  v-if="!isSmall">
                <Input
                    v-if="listbox.searchableQL"
                    type="text"
                    :placeholder="listbox.searchableQL"
                    v-model="searchText"
                    :input="setSearchText()"
                    input-class="-search-input"
                    iconButtonPrefix="search"
                    :filled="false"
                    dense
                    :outlined="true"
                />
                <Input
                    v-if="listbox.searchable"
                    type="text"
                    :placeholder="listbox.searchable"
                    v-model="listbox.searchListAll"
                    input-class="-search-input"
                    iconButtonPrefix="search"
                    :filled="false"
                    dense
                    :outlined="true"
                />
            </div>
            <div>
                <slot name="select-filter"></slot>
            </div>
        </div>
        <div class="c-listbox-list">
            <div
                v-bind:key="item.id"
                v-for="(item, index) in orderedItems"
                :class="[
                    { 'selected': item.id == listbox.selectedItem.id },
                    { 'is-deleted': item.deleted_at },
                    { 'is-hidden': listbox.searchListAll && item.name.toLowerCase().search(listbox.searchListAll.toLowerCase()) === -1},
                    { 'is-dragging': dragIndex === index },
                    { 'is-drag-over': dragOverIndex === index && dragIndex !== index },
                    { 'is-inactive': typeof item.is_active !== 'undefined' && !item.is_active },
                ]"
                @click="selectItem(item)"
                @dragover.prevent="onDragOver($event, index)"
                @dragleave="onDragLeave(index)"
                @drop.prevent="onDrop(index)"
                class="c-listbox-list__item"
                :style="(item.color) ? 'border-left: 6px solid ' + item.color : '#fff; padding-left:25px'"
            >
                <q-icon name="delete_outline" class="c-delete-button" @click="deleteItem(item)" v-if="!item.deleted_at">
                </q-icon>

                <!-- <q-icon name="bookmark" 
                    class="q-mr-sm c-listbox-list__color"
                    :style="'color: ' + item.color"
                    v-show="item.color"
                ></q-icon> -->
                <q-icon
                    v-if="useCustomOrderBy"
                    name="reorder"
                    size="16px"
                    class="q-mr-sm c-listbox-list__item-reorder"
                    color="grey"
                    draggable="true"
                    @dragstart.stop="onDragStart($event, item, index)"
                    @dragend="onDragEnd"
                    @click.stop
                ></q-icon>
                <span>{{ item.name }}</span>
                <span class="q-ml-auto text-muted" style="font-size: 9px;" v-if="typeof item.is_active !== 'undefined' && !item.is_active">(inactif)</span>
                <q-icon v-if="item.icon" :name="item.icon" :color="item.iconColor" class="q-ml-auto -name-icon"></q-icon>
                <div class="c-listbox-item__controls" v-if="listbox.actionButton" style="float:right">
                    <input type="button" class="o-button -md"
                        @click.prevent="$emit('action', item)"
                        value="Ajouter"
                    >
                </div>
            </div>
            <div v-if="!embedded" class="flex-spacer"></div>
        </div>
        <div class="c-listbox__controls" style="flex-wrap: wrap">
            <div class="-showDeleted nowrap" v-if="deletedShowable">
                <label class="-button" :class="{ '-active': showDeleted }">
                    <!-- <q-checkbox size="22px" v-model="checkShowDeleted" :value="showDeleted" :label="deletedLabel" /> -->
                    <input class="is-hidden" type="checkbox" v-model="checkShowDeleted" :value="showDeleted" />
                    <q-icon name="delete" size="16px" />
                </label>
            </div>
            <!-- <div class="-showDeleted nowrap q-mb-sm" v-if="deletedShowable">
                <q-checkbox size="22px" v-model="checkShowDeleted" :value="showDeleted" :label="deletedLabel" />
            </div> -->
            <div class="q-mr-auto" v-if="loading">
                <span class="-loading">
                    <q-spinner size="1em" class="" />
                </span>
            </div>

            <div v-if="listbox.copyButton && listbox.selectedItem.id" class="q-ml-auto">
                <div class="-button">
                    <q-icon name="content_copy" size="16px"
                        @click="$emit('duplicate-item')"
                        v-if="listbox.copyButton && listbox.selectedItem.id"
                    ></q-icon>
                </div>
            </div>
            <!-- <button type="button" class="o-button -md" v-if="listbox.copyButton && listbox.selectedItem.id" @click.prevent="$emit('duplicate-item')">
                <span v-if="!embedded" class="q-mr-xs">{{ listbox.copyButton }}</span>
                <q-icon name="content_copy" size="10px" class="o-ico"
                    :class="{'q-ml-xs' : !embedded,
                    'q-ml-none' : embedded}"
                ></q-icon>
            </button> -->
<!-- {{ showDeleted }} -->
            

            <div>
                <div class="-button">
                    <q-icon name="add" class="o-ico" size="16px"
                        @click="$emit('set-new-item')"
                    ></q-icon>
                </div>
            </div>

            <!-- <button type="button" class="o-button -md -blue q-ml-xs" @click="$emit('set-new-item')" v-if="listbox.addButton">
                <span v-if="!embedded || embedded" class="q-mr-xs">{{ listbox.addButton }}</span>
                <q-icon name="add" class="o-ico"
                    :class="{
                        'q-ml-xs': !embedded || embedded}"
                ></q-icon>
            </button> -->
            <!-- <q-btn icon="add" :label="listbox.addButton" no-caps rounded size="xs" color="primary" @click="$emit('set-new-item')" v-if="listbox.addButton">
            </q-btn> -->

        </div>
        <!-- <pre>{{ listbox }}</pre> -->

        <div class="row" v-if="!embedded">
            <small class="q-ml-lg q-mt-xs">
                <slot name="custom-order-by"></slot>
            </small>
            <small class="q-ml-auto q-mt-xs">
                {{ orderedItems.length }} éléments
            </small>
        </div>

    </div>
</template>

<script>
    import debounce from "lodash/debounce";
    import orderBy from "lodash/orderBy";

    export default {
        name: 'listbox',
        props: [
            "listbox", "embedded", "deletedShowable", "sorted", "showDeleted", "isSmall", "loading", "useCustomOrderBy"
        ],
        data(){
            return {
                searchText: null,
                lastSearchText: '',
                // showDeleted: false,
                deletedLabel: null,
                checkShowDeleted: false,
                dragIndex: null,
                dragOverIndex: null,
                draggedItem: null,
            }
        },
        mounted: async function () {
            if (!this.deletedLabel || this.deletedLabel == '') this.deletedLabel = 'Éléments supprimés';
            this.checkShowDeleted = this.showDeleted;
            // if(this.listbox.listItems.length>10) this.searchableQL=this.listbox.searchableQL;
        },
        methods: {
            selectItem(item) {
                this.$emit('selected', item)
            },
            setSearchText: debounce(function(){
                if(this.searchText===null || this.lastSearchText==this.searchText) return;
                this.$emit('set-search-text', this.searchText);
                this.lastSearchText=this.searchText;
                if(this.searchText=="") this.searchText=null
            }, 500),
            deleteItem(item) {
                let result=confirm('Êtes-vous certain de vouloir supprimer l\'élément «' + item.name + '» ?')
                if(result) this.$emit('delete-item', item)
            },
            onDragStart(event, item, index) {
                this.dragIndex = index;
                this.draggedItem = item;
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', String(item.id));
            },
            onDragOver(event, index) {
                if (this.dragIndex === null || !this.useCustomOrderBy) return;
                event.dataTransfer.dropEffect = 'move';
                this.dragOverIndex = index;
            },
            onDragLeave(index) {
                if (this.dragOverIndex === index) this.dragOverIndex = null;
            },
            onDrop(index) {
                if (this.dragIndex === null || !this.draggedItem || !this.useCustomOrderBy) return;

                const fromIndex = this.dragIndex;
                const toIndex = index;
                const itemId = this.draggedItem.id;

                if (fromIndex !== toIndex) {
                    const items = this.listbox.listItems;
                    const [moved] = items.splice(fromIndex, 1);
                    // After removal, indexes after fromIndex shift left by 1
                    const insertIndex = fromIndex < toIndex ? toIndex - 1 : toIndex;
                    items.splice(insertIndex, 0, moved);
                    this.$emit('update-order', { id: itemId, index: insertIndex });
                }

                this.resetDrag();
            },
            onDragEnd() {
                this.resetDrag();
            },
            resetDrag() {
                this.dragIndex = null;
                this.dragOverIndex = null;
                this.draggedItem = null;
            },
        },
        watch: {
            checkShowDeleted: function () {
                this.$emit('set-show-deleted', this.checkShowDeleted)
            }
        },
        computed: {
            orderedItems: function () {
                if ( this.searchText || this.sorted ) return this.listbox.listItems;
                return orderBy(this.listbox.listItems, [item => item.name.toLowerCase()]);
            }
        }

    }
</script>

<style lang="scss">
    @import "@/scss/components/globals/Listbox.scss";
    
    .c-listbox-list .-name-icon {
        color: $color-0-light;
    }

    .c-listbox-list__item {
        position: relative;

        .c-listbox-list__item-reorder {
            position: absolute;
            right: 0;
            top: 7px;
            cursor: grab;
            z-index: 2;
        }

        &.is-dragging {
            opacity: 0.4;
        }

        &.is-drag-over {
            border-top: 2px solid $color-6;
        }
    }
</style>
